module.exports = __webpack_public_path__ + "img/PuckbyQrespi-poster_bg-m.cc044e8c.jpg";